import withTranslation from '../../../../globals/components/withTranslation'
import Component from './component'
import { TransportationProps } from './types'

export default withTranslation(Component) as React.ComponentClass<TransportationProps>
